import { RequestQuery } from 'common';

import type { TeamAssignmentsQueryParams } from './types';

export const getTeamAssignmentsQueryKeyPrefix = () =>
  ['quotes', 'teamAssignments'] as const;

export type TeamAssignmentsQueryKeyPrefixType = ReturnType<
  typeof getTeamAssignmentsQueryKeyPrefix
>;

export type TeamAssignmentsQueryKeyType = [
  ...TeamAssignmentsQueryKeyPrefixType,
  RequestQuery<TeamAssignmentsQueryParams> | undefined,
];

export const getTeamAssignmentsQueryKey = (
  query?: RequestQuery<TeamAssignmentsQueryParams>,
): TeamAssignmentsQueryKeyType => [
  ...getTeamAssignmentsQueryKeyPrefix(),
  query,
];
